// src/components/logo/logo.styles.tsx
import { tv } from "tailwind-variants";
var logo = tv({
  slots: {
    image: "object-contain bg-neutral-0",
    initialsContainer: "bg-default-200 text-secondary"
  },
  compoundSlots: [
    {
      slots: ["image", "initialsContainer"],
      className: "font-medium rounded-lg border-2 border-neutral-200 flex justify-center items-center select-none"
    }
  ],
  variants: {
    size: {
      xs: {
        image: "min-w-9 min-h-9 w-9 h-9",
        //36px
        initialsContainer: "min-w-9 min-h-9 w-9 h-9 text-xl"
      },
      sm: {
        image: "min-w-14.5 min-h-14.5 w-14.5 h-14.5",
        //54px
        initialsContainer: "min-w-14.5 min-h-14.5 w-14.5 h-14.5 text-2xl"
      },
      md: {
        image: "min-w-18 min-h-18 w-18 h-18",
        //72px
        initialsContainer: "min-w-18 min-h-18 w-18 h-18 text-[2.5rem]"
      },
      lg: {
        image: "min-w-24 min-h-24 w-24 h-24",
        //96px
        initialsContainer: "min-w-24 min-h-24 w-24 h-24 text-5xl"
      }
    }
  }
});
export {
  logo
};
